import React, { useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import { GameModalLayout } from "../common";
import { Typography } from "@material-ui/core";
import { checkGameStatus } from "../../service/logic";
import { makeStyles } from "@material-ui/core/styles";
import { InputChecklist } from "../common/input-checklist";

const useStyles = makeStyles((theme) => ({
  writing: {
    width: "100%",
    display: "flex",
    marginTop: 13,
    alignItems: "flex-start",
    borderRadius: 10,
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

const FinalDiagnosis = () => {
  useEffect(() => {
    // check if user is allowed to enter final diagnosis page
    if (!checkGameStatus(GAME_STAGE.FINAL_DIAGNOSIS)) {
      // if not allowed, navigate to case list page
      history.push("/cases");
    }
  }, []);

  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <GameModalLayout
        full
        left={
          <div className={classes.root}>
            <Typography variant="h2">Final Diagnosis</Typography>
            <div className={classes.writing}>
              <InputChecklist
                type="final"
                title="Final Diagnosis"
                details="Write your final diagnosis here"
                one
              />
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

export default FinalDiagnosis;
